import { styled } from '@sds-system/system';
import type { CSSObject } from '@sds-system/types';
import {
  getAllStyledProps,
  getColorStyles,
  getCommonStyles,
  getCSSStyles,
  getFlexStyles,
  getLayoutStyles,
  getOpacityStyles,
  getShadowStyles,
  getTypographyStyles,
  getZIndexStyles,
} from '@sds-system/utils';
import type {
  StyledTableBodyProps,
  StyledTableHeaderProps,
  StyledTableProps,
  StyledTableRootProps,
  StyledTdProps,
  StyledThProps,
  StyledTrProps,
  TableSizeKey,
} from './Table.types';

const tableStyledProps = [
  getCommonStyles,
  getLayoutStyles,
  getColorStyles,
  getOpacityStyles,
  getShadowStyles,
  getTypographyStyles,
  getFlexStyles,
  getZIndexStyles,
  getCSSStyles,
];

export const cellSizeStyle: Record<TableSizeKey, CSSObject> = {
  L: {
    padding: '0px 16px',
  },
  XL: {
    padding: '0px 16px',
  },
  M: {
    padding: '0px 16px',
  },
  S: {
    padding: '0px 12px',
  },
};

export const StyledTableRoot = styled('div')<StyledTableRootProps>(({ scrollX, scrollY }) => {
  return {
    width: scrollX || '100%',
    height: scrollY || '100%',
  };
}, getAllStyledProps);

export const StyledTable = styled('table')<StyledTableProps>(({ isScroll }) => {
  return {
    width: '100%',
    height: '100%',
    ...(isScroll && {
      width: 'max-content',
      overflowX: 'auto',
      overflowY: 'auto',
    }),
  };
}, tableStyledProps);

export const StyledTableHeader = styled('thead')<StyledTableHeaderProps>(({ isScroll }) => {
  return {
    width: '100%',
    ...(isScroll && {
      position: 'sticky',
      insetBlockStart: 0,
    }),
  };
}, getAllStyledProps);

export const StyledTableBody = styled('tbody')<StyledTableBodyProps>(() => {
  return {
    width: '100%',
  };
}, getAllStyledProps);

export const StyledTr = styled('tr')<StyledTrProps>(() => {
  return {
    width: '100%',
  };
}, getAllStyledProps);

export const StyledTh = styled('th')<StyledThProps>(({ theme, size, textAlign = 'center' }) => {
  return {
    height: theme.size[size],
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.bg.tertiary,
    borderBottom: `1px solid ${theme.palette.border.secondary}`,
    verticalAlign: 'middle',
    wordBreak: 'break-all',
    textAlign,
    ...theme.typography.body2.regular,
    ...cellSizeStyle[size],
  };
}, getAllStyledProps);

export const StyledTd = styled('td')<StyledTdProps>(({ theme, size, textAlign = 'center' }) => {
  return {
    height: theme.size[size],
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.bg.primary,
    borderBottom: `1px solid ${theme.palette.border.secondary}`,
    verticalAlign: 'middle',
    wordBreak: 'break-all',
    textAlign,
    ...theme.typography.body2.regular,
    ...cellSizeStyle[size],
  };
}, getAllStyledProps);
